import actions from './actions';

const initState = {
    loader: true,
    error: '',
    purchaseSettlementDetails: []
};

export default function purchaseSettlementReducer(state = initState, action) {
    switch (action.type) {
        case actions.PURCHASE_SETTLEMENT_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.PURCHASE_SETTLEMENT_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: false,
                purchaseSettlementDetails: action.payload,
            };
        }
        case actions.PURCHASE_SETTLEMENT_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
            };
        }
        default:
            return state;
    }
}